var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"logo",staticStyle:{"margin-left":"auto","margin-right":"auto","margin-top":"74px","margin-bottom":"30px"},attrs:{"src":_vm.logoUrl}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }